var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$store.state.isAuthenticated)?_c('app-bar'):_vm._e(),_c('v-main',{staticClass:"blue-grey lighten-5"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }